<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
      <Tabs value="all" @on-click="onClickTab">
        <TabPane label="全部订单" name="all"></TabPane>
      </Tabs>
    </div>
    <listDetail :tagId="tagId"></listDetail>
  </div>
</template>
<script>
import listDetail from './listDetail'
export default {
  name: 'goodsList',
  components: { listDetail },
  data () {
    return {
      tagId: 'all'
    }
  },
  created () {
  },
  methods: {
    onClickTab (val) {
      this.tagId = val
    }
  }
}
</script>
